import { http } from './http';
import { ROUTES } from './config';
import type { RoleRecord } from '../types/domain';

/** RolesController client — admin only. Built-in roles are never created/deleted here (see
 * RoleRecord.isBuiltIn); this only manages real custom roles. */
export const rolesApi = {
  list(): Promise<RoleRecord[]> {
    return http.get(ROUTES.roles);
  },

  create(body: { name: string; description?: string }): Promise<RoleRecord> {
    return http.post(ROUTES.roles, body);
  },

  remove(id: string): Promise<void> {
    return http.delete(`${ROUTES.roles}/${id}`);
  },
};
